namespace TerminalApp {
    export class PlacementInfoBox {
        container: HTMLElement;
        raw_data: string;
        id: number;
        template: number;
        hall: string;
        toteName: string;
        section: string;
        unit: string;
        row: string;
        place: string;
        sub: string;
        prefix: string;
        refill: boolean;
        pronounciation: string;
        string_location: string;
        icon: HTMLImageElement;
        itemInfo: SP.ItemInfo;
        constructor(string_data: string, createHtml: boolean, iteminfo: SP.ItemInfo, quantity: number = null, distance: number = null) {
            this.itemInfo = iteminfo;
            this.raw_data = string_data;
            let data = string_data.split('|');
            this.id = parseInt(data[0]);
            this.template = parseInt(data[1]);
            this.hall = data[2];
            this.section = data[3];
            this.unit = data[4];
            this.row = data[5];
            this.place = data[6];
            this.sub = data[7];
            this.prefix = data[8];
          this.refill = data[9] == "1";
          console.log("template", this.template);
            //Tote
            if (this.template == 0) {
                this.pronounciation = `Tote ${this.hall}`;
                this.string_location = `Tote ${this.hall}`;
                this.toteName = data[2];
                this.hall = "Tote";
            }
            else if (this.itemInfo != null && this.section == "import" && this.itemInfo.importPlacementName) {
                this.pronounciation = `${(this.itemInfo.importPlacementName as any).replaceAll('-', ' .. ')}`;
                this.string_location = `${this.itemInfo.importPlacementName}`;
            }
            //seperate unit and no place
            else if (this.template == 3 || this.template == 4 || this.template == 7) {
                this.pronounciation = `${this.prefix}${this.section} .. ${this.unit} ${this.row}`;
                this.string_location = `${SP.Localize("word_hall")} ${this.hall} | ${this.prefix}${this.section.toUpperCase()} | ${this.unit} | ${this.row}`;
            }
            //seperate unit and no place
            else if (this.template == 13) {
              this.pronounciation = `${this.prefix}${this.section} .. ${this.row} ${this.unit}`;
              this.string_location = `${SP.Localize("word_hall")} ${this.hall} | ${this.prefix}${this.section.toUpperCase()} | ${this.row} | ${this.unit}`;
            }

            //9 med bindstreg
            else if (this.template == 9) {
                this.pronounciation = `${this.prefix}${this.section} ... ${this.unit} .. ${this.row} ${this.place}` + (this.sub != '0' ? ` .. ${SP.Localize("word_number")} ${this.sub}` : "");
                this.string_location = `${SP.Localize("word_hall")} ${this.hall} | ${this.prefix}${this.section.toUpperCase()}-${this.unit} | ${this.row} | ${this.place}` + (this.sub != '0' ? ` | ${this.sub}` : "");
            }

            //all seperated
            else if (this.template == 8 || this.template == 12) {
                this.pronounciation = `${this.prefix}${this.section} ... ${this.unit} .. ${this.row} .. ${this.place}` + (this.sub != '0' ? ` .. ${SP.Localize("word_number")} ${this.sub}` : "");
                this.string_location = `${SP.Localize("word_hall")} ${this.hall} | ${this.prefix}${this.section.toUpperCase()} | ${this.unit} | ${this.row} | ${this.place}` + (this.sub != '0' ? ` | ${this.sub}` : "");
            }

            //all seperated no row
            else if (this.template == 11) {
                this.pronounciation = `${this.prefix}${this.section} ... ${this.unit} .. ${this.place}` + (this.sub != '0' ? ` .. ${SP.Localize("word_number")} ${this.sub}` : "");
                this.string_location = `${SP.Localize("word_hall")} ${this.hall} | ${this.prefix}${this.section.toUpperCase()} | ${this.unit} | ${this.place}` + (this.sub != '0' ? ` | ${this.sub}` : "");
            }

            //default (no place, or sub)
            else if (this.template == 10) {
                this.pronounciation = `${this.prefix}${this.section}${this.unit} .. ${this.row}`;
                this.string_location = `${SP.Localize("word_hall")} ${this.hall} | ${this.prefix}${this.section.toUpperCase()}${this.unit} | ${this.row}`;
            }

            //default
            else {
                this.pronounciation = `${this.prefix}${this.section}${this.unit} .. ${this.row} ${this.place}` + (this.sub != '0' ? ` .. ${SP.Localize("word_number")} ${this.sub}` : "");
                this.string_location = `${SP.Localize("word_hall")} ${this.hall} | ${this.prefix}${this.section.toUpperCase()}${this.unit} | ${this.row} | ${this.place}` + (this.sub != '0' ? ` | ${this.sub}` : "");
            }

            if (!createHtml) return;

            this.container = document.createElement("table");
            this.container.classList.add("placement_infobox");

            //Tote
            if (this.template == 0) {
                this.container.innerHTML = `
                <tr>
                    <td><img src='/terminal/img/tote_small.png' /></td>
                    <td><span class='tote'>${this.toteName}</span></td>
                </tr>`;
            }
            else if (this.itemInfo != null && this.section == "import" && this.itemInfo.importPlacementName) {
                this.container.innerHTML = `
                <tr>
                    <td><img src='/terminal/img/shelf_small.png' /></td>
                    <td style='width:100%'><span class='tote'>${this.itemInfo.importPlacementName}</span></td>
                </tr>`;
            }
            //seperate unit and no place
            else if (this.template == 3 || this.template == 4 || this.template == 7) {
                let width = "20%";
                this.container.innerHTML = `
                <tr>
                    <td style='width:${width}'><img src='/terminal/img/shelf_small.png' /></td>
                    <td style='width:${width}' class='hall'><span class='title'>${SP.Localize("word_hall").toUpperCase()}</span>${this.hall}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_section").toUpperCase()}</span>${this.prefix}${this.section}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_unit").toUpperCase()}</span>${this.unit}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_shelf").toUpperCase()}</span>${this.row}</td>
                </tr>`;
            } else if (this.template == 13) {
              let width = "20%";
              this.container.innerHTML = `
                <tr>
                    <td style='width:${width}'><img src='/terminal/img/shelf_small.png' /></td>
                    <td style='width:${width}' class='hall'><span class='title'>${SP.Localize("word_hall").toUpperCase()}</span>${this.hall}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_section").toUpperCase()}</span>${this.prefix}${this.section}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_shelf").toUpperCase()}</span>${this.row}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_unit").toUpperCase()}</span>${this.unit}</td>
                </tr>`;
            }


            //9 uden nuller
            else if (this.template == 9) {
                let width = this.sub != '0' ? "16.666%" : "20%";
                this.container.innerHTML = `
                <tr>
                    <td style='width:${width}'><img src='/terminal/img/shelf_small.png' /></td>
                    <td style='width:${width}' class='hall'><span class='title'>${SP.Localize("word_hall").toUpperCase()}</span>${this.hall}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_section").toUpperCase()}</span>${this.prefix}${this.section}-${this.unit}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_shelf").toUpperCase()}</span>${this.row}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_place").toUpperCase()}</span>${this.place}</td>
                    ${this.sub != '0' ? `<td style='width:${width}'><span class='title'>${SP.Localize("word_number").toUpperCase()}</span>${this.sub}</td>` : ""}
                </tr>`;
            }

            //all seperate
            else if (this.template == 8 || this.template == 12) {
                let width = this.sub != '0' ? "16.666%" : "20%";
                this.container.innerHTML = `
                <tr>
                    <td style='width:${width}'><img src='/terminal/img/shelf_small.png' /></td>
                    <td style='width:${width}' class='hall'><span class='title'>${SP.Localize("word_hall").toUpperCase()}</span>${this.hall}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_section").toUpperCase()}</span>${this.prefix}${this.section}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_unit").toUpperCase()}</span>${this.unit}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_shelf").toUpperCase()}</span>${this.row}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_place").toUpperCase()}</span>${this.place}</td>
                    ${this.sub != '0' ? `<td style='width:${width}'><span class='title'>${SP.Localize("word_number").toUpperCase()}</span>${this.sub}</td>` : ""}
                </tr>`;
            }


            //all seperate no row
            else if (this.template == 11) {
                let width = this.sub != '0' ? "20%" : "25%";
                this.container.innerHTML = `
                <tr>
                    <td style='width:${width}'><img src='/terminal/img/shelf_small.png' /></td>
                    <td style='width:${width}' class='hall'><span class='title'>${SP.Localize("word_hall").toUpperCase()}</span>${this.hall}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_section").toUpperCase()}</span>${this.prefix}${this.section}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_unit").toUpperCase()}</span>${this.unit}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_place").toUpperCase()}</span>${this.place}</td>
                    ${this.sub != '0' ? `<td style='width:${width}'><span class='title'>${SP.Localize("word_number").toUpperCase()}</span>${this.sub}</td>` : ""}
                </tr>`;
            }

            //default (no place, or sub)
            else if (this.template == 10) {
                let width = "25%";
                this.container.innerHTML = `
                <tr>
                    <td style='width:${width}'><img src='/terminal/img/shelf_small.png' /></td>
                    <td style='width:${width}' class='hall'><span class='title'>${SP.Localize("word_hall").toUpperCase()}</span>${this.hall}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_section").toUpperCase()}</span>${this.prefix}${this.section}${this.unit}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_shelf").toUpperCase()}</span>${this.row}</td>
                </tr>`;
            }

            //default
            else {
                let width = this.sub != '0' ? "16.666%" : "20%";
                this.container.innerHTML = `
                <tr>
                    <td style='width:${width}'><img src='/terminal/img/shelf_small.png' /></td>
                    <td style='width:${width}' class='hall'><span class='title'>${SP.Localize("word_hall").toUpperCase()}</span>${this.hall}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_section").toUpperCase()}</span>${this.prefix}${this.section}${this.unit}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_shelf").toUpperCase()}</span>${this.row}</td>
                    <td style='width:${width}'><span class='title'>${SP.Localize("word_place").toUpperCase()}</span>${this.place}</td>
                    ${this.sub != '0' ? `<td style='width:${width}'><span class='title'>${SP.Localize("word_number").toUpperCase()}</span>${this.sub}</td>` : ""}
                </tr>`;
            }

            this.container.querySelector("img").addEventListener("click", (e) => {
                placementShortcutAssistant.open_with_data(this.raw_data, this.itemInfo);
                e.preventDefault();
                e.stopPropagation();
            });


            var tr = this.container.querySelector("tr");



            if (this.refill) {
                var distance_div = document.createElement("div");
                distance_div.classList.add("label", "badge", "lot_count_info", "refill");
                distance_div.innerHTML = "Refill";

                var td = document.createElement("td");
                td.appendChild(distance_div);
                tr.appendChild(td);
            }

            if (quantity != null) {
                var remaining_count = document.createElement("div");
                remaining_count.classList.add("label", "badge", "lot_count_info");
                remaining_count.innerHTML = "<small>Qty</small><br />" + quantity.toString();

                var td = document.createElement("td");
                td.appendChild(remaining_count);
                tr.appendChild(td);
            }

            if (distance != null) {
                var distance_div = document.createElement("div");
                distance_div.classList.add("label", "badge", "lot_count_info");
                distance_div.style.backgroundColor = "#3a4d75";
                distance_div.innerHTML = "<small>" + SP.Localize("word_distance") + "</small><br />" + distance.toFixed(1) + "m";

                var td = document.createElement("td");
                td.appendChild(distance_div);
                tr.appendChild(td);
            }

     


        }
    }
}